import React, {useEffect} from "react";
import {SidebarCardWorkerNew} from "../SidebarCard/SidebarCardWorkerNew";
import {SidebarCardStackHolders} from "../SidebarCard/SidebarCardStackHolders";
import {SidebarTab} from "../Sidebar";
import {
  IPeople,
  IPrevPeople,
} from "../../pages/StateInitiative/StateInitiative.type";
import {apiKeyDataCRGCI, urlApiDataCRGCI} from "../../helper/api";

interface WorkerViewProps {
  activeWorker: IPeople;
  setActiveWorker: (worker: IPeople) => void;
  arrPersonsWorker: IPeople[];
  setArrPersonsWorker: (workers: IPeople[]) => void;
  idWorkerShowConnections: string;
  setIdWorkerShowConnections: (id: string) => void;
  prevIdWorker: IPrevPeople[];
  setPrevIdWorker: (prev: IPrevPeople[]) => void;
  isWorkerLoading: boolean;
  setIsWorkerLoading: (loading: boolean) => void;
  isOpenSideBarStackHolders: boolean;
  setIsOpenSideBarStackHolders: (isOpen: boolean) => void;
  openSidebarWithTab: (
    tab: SidebarTab,
    directionId: number | string,
    trendId?: number | string,
    trendTitle?: string,
    sectionName?: string,
    segmentColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: number | string,
    typeRadar?: any,
    isSearchPanelActive?: boolean
  ) => void;
  isLogin: boolean;
  role: string | null;
  userIdAuth: string | null;
  roleAuth: string | null;
}

export const WorkerView: React.FC<WorkerViewProps> = ({
  activeWorker,
  setActiveWorker,
  arrPersonsWorker,
  setArrPersonsWorker,
  idWorkerShowConnections,
  setIdWorkerShowConnections,
  prevIdWorker,
  setPrevIdWorker,
  isWorkerLoading,
  setIsWorkerLoading,
  isOpenSideBarStackHolders,
  setIsOpenSideBarStackHolders,
  openSidebarWithTab,
  isLogin,
  role,
  userIdAuth,
  roleAuth,
}) => {
  useEffect(() => {
    if (idWorkerShowConnections) {
      setIsWorkerLoading(true);

      const fetchWorkerData = async () => {
        const crgciUrl = new URL(`${urlApiDataCRGCI}/api/people`);
        crgciUrl.searchParams.set(
          "filters[documentId][$eq]",
          idWorkerShowConnections
        );
        crgciUrl.searchParams.set(
          "populate[connections][populate][0]",
          "photo"
        );
        crgciUrl.searchParams.set("populate[photo]", "true");
        crgciUrl.searchParams.set(
          "populate[initiatives][populate][0]",
          "initiative"
        );
        crgciUrl.searchParams.set("populate[comments][populate][0]", "author");

        try {
          const response = await fetch(crgciUrl.toString(), {
            headers: {
              Authorization: `Bearer ${apiKeyDataCRGCI}`,
              "Content-Type": "application/json",
            },
          });

          if (response.ok) {
            const workerApiData = await response.json();

            if (workerApiData.data && workerApiData.data.length > 0) {
              const personData = workerApiData.data[0];

              const workerData = {
                id: personData.id || 0,
                documentId: personData.documentId,
                fullName: personData.fullName,
                department: personData.department,
                role: personData.jobFunction,
                phoneNumber: personData.phoneNumber,
                email: personData.email,
                organization: personData.organization,
                photo: personData.photo,
                connections: personData.connections || [],
                createdAt: personData.createdAt,
                updatedAt: personData.updatedAt,
                publishedAt: personData.publishedAt,
                jobFunction: personData.jobFunction,
                interactionLevel: personData.interactionLevel,
                initiatives: personData.initiatives || [],
                comments: personData.comments || [],
              };

              setActiveWorker(workerData as any);

              if (personData.connections && personData.connections.length > 0) {
                const connectionsData = personData.connections.map(
                  (connection: any) => ({
                    ...connection,
                    role: connection.jobFunction || connection.role || "",
                    department: connection.department || "",
                    connections: connection.connections || [],
                    photo: connection.photo || null,
                  })
                );
                setArrPersonsWorker(connectionsData);
              }

              setIsWorkerLoading(false);
            } else {
              console.error(
                "No worker data found for:",
                idWorkerShowConnections
              );
              setIsWorkerLoading(false);
            }
          } else {
            console.error(`HTTP ${response.status}: ${response.statusText}`);
            setIsWorkerLoading(false);
          }
        } catch (error) {
          console.error("Error fetching worker data:", error);
          setIsWorkerLoading(false);
        }
      };

      fetchWorkerData();
      setIdWorkerShowConnections("");
    }
  }, [
    idWorkerShowConnections,
    setActiveWorker,
    setArrPersonsWorker,
    setIsWorkerLoading,
    setIsOpenSideBarStackHolders,
    setIdWorkerShowConnections,
  ]);

  return (
    <>
      <SidebarCardWorkerNew
        isOpen={isOpenSideBarStackHolders}
        activeWorker={activeWorker}
        onClose={() => setIsOpenSideBarStackHolders(false)}
        arrPersonsWorker={arrPersonsWorker}
        setIdWorkerShowConnections={setIdWorkerShowConnections}
        prevIdWorker={prevIdWorker}
        setPrevIdWorker={setPrevIdWorker}
        isLoading={isWorkerLoading}
        openSidebarWithTab={openSidebarWithTab}
        isLogin={isLogin}
        role={role}
        userIdAuth={userIdAuth}
        roleAuth={roleAuth}
      />

      <SidebarCardStackHolders
        isOpen={true}
        activeWorker={activeWorker}
        onClose={() => setIsOpenSideBarStackHolders(false)}
        arrPersonsWorker={arrPersonsWorker}
        setIdWorkerShowConnections={setIdWorkerShowConnections}
        prevIdWorker={prevIdWorker}
        setPrevIdWorker={setPrevIdWorker}
        isLoading={isWorkerLoading}
      />
    </>
  );
};
